import { render, staticRenderFns } from "./CardPromoter.vue?vue&type=template&id=6879f313&scoped=true&"
import script from "./CardPromoter.vue?vue&type=script&lang=js&"
export * from "./CardPromoter.vue?vue&type=script&lang=js&"
import style0 from "./CardPromoter.vue?vue&type=style&index=0&id=6879f313&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6879f313",
  null
  
)

export default component.exports
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QIcon});
